import { Action } from "@ngrx/store";
import { AlertButtonStyle } from "@obg/mat.ui.core";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { MessageType } from "@obg/ngx.core";

export const SESSION_LIMIT_REMINDER_ALERT_ID = "SESSION_LIMIT_REMINDER_ALERT";

export interface CustomerLimitSnackBarPayload {
	message: string;
	type: MessageType;
	doNotShowAgainButton: boolean;
	id?: string;
	prefixJurisdiction?: boolean;
	keepOpen?: boolean;
	dismissibleDuration?: number;
	duration?: number;
	interpolateParams?: object | undefined;
	dismissible?: boolean;
}

export interface CustomerLimitAlertPayload {
	limitPrefix: string;
	redirectButtonAction: Action | ActionWithPayload<any>;
	prefixJurisdiction?: boolean;
	buttonStyle?: AlertButtonStyle;
}

export interface SessionLimitNotificationPayload {
	usedSessionTimeInMillis?: number;
	remainingSessionTimeInMillis?: number;
}
